// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__wcIQH","tableHeader":"table_tableHeader__14mrI","tableColumn":"table_tableColumn__1dnlM","tableBody":"table_tableBody__16u3q"};